export const viewJobSelector = state => state.viewJobDetails;